import React from "react";
import TopFiltersContainer from "./active-filters/top-filters/TopFiltersContainer";
import type { AdditionalModalsType } from "../../../../common-deprecated/hooks/useStatus";
import useStatus from "../../../../common-deprecated/hooks/useStatus";
import { useModalMap } from "../../../../common-deprecated/containers/ModalProvider";
import CarResultsContainer from "./car-results/CarResultsContainer";
import * as Container from "../../../../common-deprecated/styles/v2/lexus/globals/Container";
import { useCarFilterSelector } from "../../redux/store";
import { CAR_FILTER_ID } from "../../utils/constants/filterConstants";
import { EnvironmentEnum } from "../../../../common-deprecated/utils";
import useCarFilter from "../../hooks/useCarFilter";
import PageDisclaimers from "./common/PageDisclaimers";
import { aemLexusCarFilterModalMap } from "./floating-elements/modals/modals";
import { MODAL_FILTER_CONFIG_HELPER } from "../../utils/modalConstants";
import DualCurrencyDisclaimer from "../../../shared-components/lexus/dual-currency-disclaimer/DualCurrencyDisclaimer";
import { UscContext } from "../../../shared-logic/types/UscCommonTypes";
import { getUscExtraQueryBuilderOptions } from "../../../shared-logic/utils/uscUtils";
import * as Background from "../../../../common-deprecated/styles/v2/lexus/components/Background";
import { MODAL_VEHICLE_FOR_SALE_ID } from "../../../shared-logic/utils/modalConstants";
import { useComponentRegistry } from "./componentRegistry";
import GlobalStyle from "../../../shared-components/lexus/styles/Global.styles";

const CarFilter = (): JSX.Element => {
    const commonSettings = useCarFilterSelector((state) => state.commonSettings);
    const currentFilter = useCarFilterSelector((state) => state.carFilters.currentFilter);
    const carFilterSettings = useCarFilterSelector((state) => state.carFilterSettings);
    const hideTopFilters = carFilterSettings.hideTopFilters[currentFilter];
    const { noContainerSpacing } = commonSettings.layoutOptions;

    const additionalModals: AdditionalModalsType =
        commonSettings.environment !== EnvironmentEnum.Production
            ? [
                  { key: "f", settings: { type: MODAL_FILTER_CONFIG_HELPER } },
                  {
                      key: "i",
                      settings: {
                          type: MODAL_VEHICLE_FOR_SALE_ID,
                          detailPageUrl: carFilterSettings.urlDetailPage[currentFilter],
                          landingPageUrl: carFilterSettings.urlLandingPage[currentFilter],
                      },
                  },
              ]
            : [];

    const extraQueryBuilderOptions = getUscExtraQueryBuilderOptions(commonSettings);
    useStatus(commonSettings, "Car Filter", [], additionalModals, extraQueryBuilderOptions);

    useCarFilter();
    useModalMap(aemLexusCarFilterModalMap);

    const MobileStaticFilterBar = useComponentRegistry("MobileStaticFilterBar");
    const StaticFilterBar = useComponentRegistry("StaticFilterBar");
    const UsedCompareV2 = useComponentRegistry("IntegratedUsedCompareWrapper");
    const CarResultsContainerWrapper = useComponentRegistry("CarResultsContainerWrapper");
    const PageFinanceDisclaimer = useComponentRegistry("PageFinanceDisclaimer");

    return (
        // This id should always be on top as this is used by GFI to navigate/scroll to the component.
        <div id={CAR_FILTER_ID}>
            <GlobalStyle />
            {currentFilter !== UscContext.Stock && (
                // If compare is ever enabled for stock cars, make sure to also re-enable compare data fetch.
                <UsedCompareV2 />
            )}

            {!hideTopFilters && (
                <Background.Mist>
                    <TopFiltersContainer />
                </Background.Mist>
            )}

            <PageFinanceDisclaimer />

            <Background.Mist>
                <StaticFilterBar />
                <MobileStaticFilterBar />

                <Container.default
                    maxWidth="1600px"
                    px={noContainerSpacing ? "0px" : { _: "24px !important", xxxl: "0 !important" }}
                >
                    <DualCurrencyDisclaimer />
                </Container.default>

                <CarResultsContainerWrapper>
                    <CarResultsContainer />
                </CarResultsContainerWrapper>
            </Background.Mist>

            <PageDisclaimers />
        </div>
    );
};

export default CarFilter;
